import React from 'react';
import { Box, Typography } from '@material-ui/core';
import NoteItem from './NoteItem';

interface Props {
  note: any;
}

// Minimal LinkedNoteResolver extracted as a separate component.
// For now it renders the generic NoteItem (title/author/date) to keep behavior
// consistent with previous inline fallback, while allowing future enhancements.
const LinkedNoteResolver: React.FC<Props> = ({ note }) => {
  return (
    <Box style={{ display: 'grid', gap: 8, background: 'white', paddingTop: 8, paddingBottom: 8 }}>
      <NoteItem note={note} />
      <Typography variant="caption" color="textSecondary">
        Linked note
      </Typography>
    </Box>
  );
};

export default LinkedNoteResolver;
